import { Detail } from "../../../components/users/Detail.tsx";

export default function ProfilePage() {
  return (
    <div className="w-full h-screen overflow-hidden">
      <Detail isProfile />
    </div>
  );
}
